import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../core/persistence";

class StorageService {
  async uploadLogo(file: File, companyId: string): Promise<string> {
    try {
      const storageRef = ref(storage, `company/${companyId}/logo`);
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);
      return downloadURL;
    } catch (error) {
      console.error("Error uploading logo:", error);
      throw error;
    }
  }
}

export const storageService = new StorageService();
